{
  "09fd2948a8dffd21": "Lugar de trabajo",
  "0a5d5c335cd87d5f": "Gasto total",
  "0cd5e22fc50a93f0": "Tipo de trabajador",
  "11e9eccfeca65d0b": "Total de turnos verificados",
  "18086e0b0dca6cea": "PDF (.pdf)",
  "1cfb62875a3f4d2d": "lugares de trabajo",
  "28eaf72277d6ddf5": "No se pudo crear un enlace para compartir. Por favor intenta de nuevo.",
  "2d275a74912cca2e": "Métrica",
  "310ca503ef36f177": "Mes",
  "324ddac12d893a7d": "Lugares de trabajo",
  "354640e37ed70d16": "No hay analíticas configuradas.",
  "3664895579f0a7e6": "Exportar",
  "37e97f978d12dde7": "Gráfico de donut de {{title}} con {{count}} segmentos",
  "402e15bc3f9dc45e": "Algo salió mal al cargar esta métrica.",
  "45a82a5b34e749f0": "Excel (.xlsx)",
  "494ca78f7374e46f": "Personalizado",
  "49c6f4121e8dc55c": "Generado en",
  "4c6ad06c67817871": "Este enlace compartido ya no está disponible",
  "54a00fd5f7c2e9eb": "Totales por {{groupBy}}",
  "5822754796c65d5b": "Último año",
  "5bc86dc5fdf8f13e": "No se pudo exportar el análisis. Por favor, inténtalo de nuevo.",
  "6a00dfc1dc867e84": "Lunes",
  "6dde11117000cc15": "Filtros aplicados",
  "6e795d4d3cc21c5c": "Período",
  "757fd1902294c03e": "Año hasta la fecha",
  "78963905f399ce6f": "Fechas",
  "7d8af1de1262f150": "Martes",
  "7ff2bc6248f6e1a0": "Vista compartida · expira {{expiresLabel}}",
  "8061bfb29ce82f35": "Rango de fechas",
  "873fef760e5d001b": "Domingo",
  "8e37953d23daca5f": "Valor",
  "8e76a94ac8320d51": "Resumen",
  "8ea2a7069338c8de": "Rango de fechas",
  "8f2364e11b8be3ff": "Día",
  "94c116ee118a7299": "Analíticas",
  "956a51f6b098a41b": "Agrupar por",
  "9902d7ae89e288fb": "Últimos 90 días",
  "99e928001739da35": "Horas a lo largo del tiempo",
  "9f944f379810ac3c": "{{title}} gráfico con {{count}} series",
  "9f987627b99b3081": "Todos los lugares de trabajo",
  "a2dd9cbb7013bb70": "Exportando…",
  "a3b50c476732c740": "Estado",
  "a59ac4901542233d": "Desglose de {{title}}",
  "a757b228061803e1": "Día de la semana",
  "b474b39788978476": "Trimestre",
  "b4f514f87ca5372b": "Tasa de ocupación a lo largo del tiempo",
  "bab37d62472990c0": "Ver más",
  "c0a6cc829cd08735": "Miércoles",
  "c394113333747fff": "No hay datos para los filtros seleccionados",
  "c91b8ee8b811fb34": "Tasa de cobertura",
  "c9b3c38247f744e1": "Total",
  "cc29e6034aae6d05": "El enlace puede haber expirado o sido revocado. Pide al remitente un nuevo enlace para compartir.",
  "d0a4d1e4d6f27b61": "Tipo de turno",
  "d31483e209cd5b1d": "Copiar enlace para compartir",
  "d44c66e04b73c73f": "Gasto a lo largo del tiempo",
  "d6f2087fcd8a6070": "Intervalo de tiempo",
  "db67c5f84d851ae6": "Total de horas",
  "dbe17b25fc97a7d2": "{{count}} métricas configuradas.",
  "dbe35c7363c2f7ec": "Sábado",
  "e1c13b7cff3c6d53": "Turnos verificados a lo largo del tiempo",
  "e21f3f372a46d4be": "Viernes",
  "e2659de0c3e0ef69": "No hay datos para los filtros seleccionados.",
  "e473c8ef4e0d4ee1": "Trimestre hasta la fecha",
  "e72a1aedfa29ad42": "Enlace compartido copiado al portapapeles",
  "e78041ab51a818a2": "Semana",
  "e8233a146856d5b1": "{{count}} métrica configurada.",
  "e8ce3af01c672628": "Se creó el enlace para compartir, pero no se pudo copiar. Por favor, inténtalo de nuevo.",
  "ea1debccad839065": "Número de profesionales únicos",
  "f8f03fb441b8b4ae": "Últimos 30 días",
  "f97e9da0e3b879f0": "Otro",
  "fc2662062ffdef96": "Jueves"
}
